import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });
let refreshing;
api.interceptors.response.use(response => response, async error => {
  const config = error.config;
  if (error.response?.status === 401 && !config._retried && !config.url?.startsWith('/auth/')) {
    config._retried = true;
    try {
      refreshing ||= api.post('/auth/refresh').finally(() => { refreshing = null; });
      await refreshing;
      return api(config);
    } catch { window.dispatchEvent(new Event('session-expired')); }
  }
  return Promise.reject(error);
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (n) =>
  "$" + Math.round(n || 0).toLocaleString("en-US");

export default api;
